<template>
  <div v-if="loading" class="flex col-12 justify-content-center"
       style="position: absolute;top: 50%;transform: translate(0, -50%);">
    <ProgressSpinner></ProgressSpinner>
  </div>
  <div v-if="!loading && correctionReport !== null">
    <div class="grid">
      <div class="col-12 lg:col-4">
        <CorrectionReportCard
            :data="correctionReport"
            :after-action="this.refresh"
        />
      </div>
      <div class="col-12 lg:col-8">
        <Card>
          <template #title>Займы в отчёте</template>
          <template #content>
            <TabView>
              <TabPanel header="Займы в отчёте">
                <CorrectionReportLoansTable
                    :default-data="{reportId: correctionReport.id}"/>
              </TabPanel>
              <TabPanel header="Файлы ответа">
                <AbstractTable
                    code="reportResponses"
                    entity="correction"
                    :default-data="{reportId: correctionReport.id}"
                    display-filter="menu"
                    hide-header
                >
                  <template #actions="row">
                    <Button icon="pi pi-fw pi-download" label="Скачать" @click="downloadReportResponse(row.data.id)"></Button>
                  </template>
                </AbstractTable>
              </TabPanel>
              <TabPanel header="Ошибки">
                <AbstractTable
                    code="correctionReportErrors"
                    :default-data="{reportId: correctionReport.id}"
                    display-filter="menu"
                />
              </TabPanel>
            </TabView>
          </template>
        </Card>
      </div>
    </div>
    <div v-if="!loading && error !== null">
      <Error :message="error"/>
    </div>
  </div>
</template>

<script>
import Error from "@/components/Error.vue";
import ResponseService from "@/service/ResponseService";
import CorrectionReportCard from "@/views/Correction/CorrectionReportCard.vue";
import CRUDService from "@/service/CRUDService";
import CorrectionReportLoansTable from "@/components/tables/CorrectionReportLoansTable.vue";
import AbstractTable from "@/components/AbstractTable.vue";

export default {
  name: 'DeleteInformationPartView',
  components: {AbstractTable, CorrectionReportLoansTable, CorrectionReportCard, Error},
  data() {
    return {
      correctionReport: null,
      id: null,
      loading: true,
      error: null
    }
  },
  mounted() {
    this.id = parseInt(this.$router.currentRoute.value.params.id);
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;

      CRUDService.get('correction_report', this.id).then((res) => {
        if (Array.isArray(res) && res.length === 0) {
          throw new DOMException('Отчёт не найден')
        }
        this.correctionReport = res
        this.loading = false
        this.actionLoading = false
      }).catch((err) => {
        ResponseService.handleErrorResponseWithoutForm(err, this.$toast)
        this.error = true
        this.loading = false
      })
          .finally(() => {
            this.loading = false;
          })

    },
    refresh() {
      this.getData();
    },
    downloadReportResponse(id) {
      window.open('/download/report_response_file/' + id, '_blank')
    },
  }
}
</script>

